import React, { useEffect, useState, useRef } from "react";
import styles from "./BookDemoCall.module.css";
import DemoCall from "../DemoCall/DemoCall";
import { FiRefreshCw } from "react-icons/fi";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import side from "../../../Images/side.png";

gsap.registerPlugin(ScrollTrigger);

const BookDemoCall = () => {
  const [callOption, setCallOption] = useState("giveCall");
  const [captchaCode, setCaptchaCode] = useState("");
  const [userCaptchaInput, setUserCaptchaInput] = useState("");
  const [timer, setTimer] = useState(null);
  const [callInitiated, setCallInitiated] = useState(
    localStorage.getItem("callDone") === "true"
  );
  const [callMessage, setCallMessage] = useState("");

  const visualRef = useRef(null);
  const formRef = useRef(null);

  const handleToggle = () => {
    setCallOption(callOption === "giveCall" ? "getCall" : "giveCall");
  };

  const generateCaptcha = () => {
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let code = "";
    for (let i = 0; i < 4; i++) {
      code += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    setCaptchaCode(code);
    setUserCaptchaInput("");
  };

  useEffect(() => {
    generateCaptcha();
  }, []);

  useEffect(() => {
    if (visualRef.current && formRef.current) {
      gsap.fromTo(
        visualRef.current,
        { opacity: 0, y: 50 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          scrollTrigger: {
            trigger: visualRef.current,
            start: "top 90%",
            end: "top 50%",
            scrub: true,
            toggleActions: "play none none reverse",
          },
        }
      );

      gsap.fromTo(
        formRef.current,
        { opacity: 0, x: 50 },
        {
          opacity: 1,
          x: 0,
          duration: 1.2,
          scrollTrigger: {
            trigger: formRef.current,
            start: "top 90%",
            end: "top 50%",
            scrub: true,
            toggleActions: "play none none reverse",
          },
        }
      );
    }
  }, []);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (userCaptchaInput.trim().toUpperCase() !== captchaCode) {
      alert("Incorrect CAPTCHA code. Please try again.");
      generateCaptcha();
      return;
    }

    if (callInitiated) {
      alert("You have already initiated a demo call.");
      return;
    }

    const formData = new FormData(e.target);
    const data = {
      name: formData.get("name"),
      email: formData.get("email"),
      number: formData.get("number"),
      callOption: callOption,
    };

    if (callOption === "getCall") {
      const calls = [
        {
          number: data.number,
          from_number: "+12293409607",
          first_message:
            "Hi, my name is Aimee. I’m your AI voice calling assistant from ToxBoxAI...",
          userPrompt: `Hello! My name is Sage...`, // Shortened here
          agent_id: "agent_01jvbv4nwjf78t2sysd3vmceza",
          agentName: "Aimee",
          customerName: data.name,
          homePageCallerTimer: true,
        },
      ];

      
      try {
        const response = await fetch(
          "https://prod.toxboxai.com/outbound-call-twilio",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ calls }),
          }
        );

        const result = await response.json();
        if (result.success && result.results[0].success) {
          setTimer(150);
          setCallInitiated(true);
          localStorage.setItem("callDone", "true");
          e.target.reset();
          setUserCaptchaInput("");
          generateCaptcha();
          setCallMessage("Call initiated! Timer started.");
        } else {
          alert("Failed to initiate call. Please try again.");
          generateCaptcha();
        }
      } catch (error) {
        console.error("Error initiating call:", error);
        alert("Error initiating call. Please try again.");
        generateCaptcha();
      }
    }
  };

  useEffect(() => {
    let interval;
    if (timer !== null && timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => {
          if (prev <= 1) {
            clearInterval(interval);
            setCallMessage("Call ending automatically.");
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [timer]);

  return (
    <div className={styles.container}>
      <div className={styles.gradientBG} />

      <div className={styles.contentGrid}>
        <div
          className={`${styles.visualSection}`}
          ref={visualRef}
        >
          <img src={side} alt="avatar1" className={styles.Img} />
        </div>

        <div
          className={`${styles.formSection}`}
          ref={formRef}
        >
          <p className={styles.formSubtitle}>
            See how our AI receptionist handles
            <br /> real calls—live, smart, and seamless.
          </p>

          <form className={styles.form} onSubmit={handleSubmit}>
            <h2 className={styles.active}>Make a Call</h2>
            <label>Name</label>
            <input type="text" name="name" placeholder="Enter your name" required />
            <label>Email</label>
            <input type="email" name="email" placeholder="Enter your email" required />
            <label>Phone no</label>
            <input type="tel" name="number" placeholder="Enter phone number" required />

            <div className={styles.captchaWrapper}>
              <div className={styles.captchaBox}>{captchaCode}</div>
              <input
                type="text"
                placeholder="Enter CAPTCHA"
                value={userCaptchaInput}
                onChange={(e) => setUserCaptchaInput(e.target.value)}
                required
              />
              <button
                type="button"
                className={styles.captchaRefresh}
                onClick={generateCaptcha}
              >
                <FiRefreshCw />
              </button>
            </div>

            <button type="submit" disabled={callInitiated}>
              Call Now
            </button>
          </form>

          {timer !== null && timer > 0 && (
            <div className={styles.timer}>
              Time remaining: {formatTime(timer)}
            </div>
          )}
          {callMessage && (
            <div className={styles.callMessage}>{callMessage}</div>
          )}
        </div>
      </div>
      <DemoCall />
    </div>
  );
};

export default BookDemoCall;
